import * as Yup from 'yup';

export const serviceFormSchema = Yup.object().shape({
  serviceName: Yup.string().required('Service name is required'),
  serviceCode: Yup.string().required('Service code is required'),
  serviceGroupID: Yup.string().required('Service group is required'),
  serviceTypeID: Yup.string().required('Service type(Fastfield Service Category = PPI Only) is required'),
  notPPIOnlyServiceTypeID: Yup.string().required('Service type(Fastfield Service Category != PPI Only) is required'),
  serviceCategoryID: Yup.string().required('Service category is required'),
  billingTypeID: Yup.string().required('Billing type is required'),
  // qboAccountID: Yup.string().required('Income account is required'),
  // price: Yup.string().required('Service price is required'),
  // serviceSkillsets: Yup.array().required('Service skillsets are required'),
  // serviceEquipments: Yup.array().required('Service equipments are required'),
  //isPassFailedApplicable: Yup.string().required('Pass/Failed applicable is required'),
  isPlanReviewRequired: Yup.string().required('Plan review is required'),
});
